// eslint-disable-next-line
declare let appInsights: any;

// eslint-disable-next-line
// https://github.com/microsoft/ApplicationInsights-JS/blob/17ef50442f73fd02a758fbd74134933d92607ecf/shared/AppInsightsCommon/src/Interfaces/Contracts/Generated/SeverityLevel.ts
export enum SeverityLevel {
    Verbose = 0,
    Information = 1,
    Warning = 2,
    Error = 3,
    Critical = 4
}

// Application Insights shows [object Object] when you pass an object property, that's why this limitation is in place.
type Properties = { [key: string]: string | number | boolean | null | undefined };

export class ApplicationInsights {
    public static TrackException(message: string) {
        if (typeof appInsights !== 'undefined') {
            appInsights.trackException(message);
        }
    }

    public static TrackTrace(level: SeverityLevel, message: string, properties?: Properties) {
        if (typeof appInsights !== 'undefined') {
            appInsights.trackTrace(message, properties, level);
        }
    }

    public static TrackEvent(name: string, properties?: Properties) {
        if (typeof appInsights !== 'undefined') {
            appInsights.trackEvent(name, properties);
        }
    }
}
